import { render, staticRenderFns } from "./WegowAds.vue?vue&type=template&id=2a3a8bd5&"
import script from "./WegowAds.vue?vue&type=script&lang=js&"
export * from "./WegowAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports